import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter,Routes ,Route } from 'react-router-dom';
import Home from './Home/Home';
import Contact from './Contact/Contact';
import Navbar from './Navbar/Navbar';
import About from './About/About';
import Services from './Services/Services';


function App() {
  return (
    <div className="app" style={{fontFamily: "sofia-pro-regular",fontWeight:"400"}}>
    <BrowserRouter>
      <Navbar/>
      <div className="content">
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/about" element={<About/>} />
          <Route path="/services" element={<Services/>} />
          <Route path="/contact" element={<Contact/>} />
        </Routes>
      </div>
    </BrowserRouter>
  </div>
  );
}

export default App;
